import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNewspaper"><Path d="M16.5 12V3.5H2.5V18C2.5 19.3807 3.61929 20.5 5 20.5H19M16.5 12V18C16.5 19.3807 17.6193 20.5 19 20.5M16.5 12H21.5V18C21.5 19.3807 20.3807 20.5 19 20.5M6 15.5H13M6.5 7.5H12.5V12.5H6.5V7.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconNewspaper;
